import { FreeSpinsRetrieval, FreeSpinsRetrievalTarget } from "../types/FreeSpinsRetrieval";

import { isSameTarget } from "./isSameTarget";

/** Running, or finished with a result not yet dismissed. */
export const isPending = (
  retrievals: FreeSpinsRetrieval[],
  target: FreeSpinsRetrievalTarget,
): boolean => retrievals.some((retrieval) => isSameTarget(retrieval.target, target));
